import DistrictTransfers from "@/components/DistrictTransfers";
import { CrossDistrictTransfers } from "@/components/CrossDistrictTransfers";

export default function CorporateTransfersPage() {
  return (
    <main className="px-6 md:px-10 py-8" data-testid="corporate-transfers-page">
      <DistrictTransfers />
      <CrossDistrictTransfers />
    </main>
  );
}
